import { render, staticRenderFns } from "./blog-card-list-view.vue?vue&type=template&id=2436f40a&scoped=true&"
import script from "./blog-card-list-view.vue?vue&type=script&lang=js&"
export * from "./blog-card-list-view.vue?vue&type=script&lang=js&"
import style0 from "./blog-card-list-view.vue?vue&type=style&index=0&id=2436f40a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436f40a",
  null
  
)

export default component.exports